import React from 'react';

type ZoomButtonType = 'in' | 'out';

interface ZoomButtonProps {
    type: ZoomButtonType;
    disabled: boolean;
    mode: () => void;
}

const ZoomButton: React.FC<ZoomButtonProps> = ({ type, disabled, mode }) => (
    <button
        className={`zoom-button ${type} ${disabled ? 'disabled' : ''}`}
        onClick={() => mode()}
        role="button"
        tabIndex={0}
        aria-disabled={disabled}
    ></button>
);

export default ZoomButton;